import { useInjectReducer } from "@app/store";
import Button from "@components/Button";
import { FilterInput, FilterSelect } from "@components/FilterInputs";
import PageContent from "@components/PageContent";
import PageFilter from "@components/PageFilter";
import PageHeader from "@components/PageHeader";
import Table from "@components/Table";
import { enqueueSnackbar, makeSelectAccess } from "@features/auth/authSlice";
import {
  useDeleteShippingPartnerMutation,
  useLoadAllShippingPartnerMutation,
} from "@features/admin/shipping/shippingPartner/shippingPartnerApiSlice";
import { makeSelectQuery } from "@features/admin/shipping/shippingPartner/shippingPartnerSelector";
import shippingPartnerSlice, {
  setQueryValue,
} from "@features/admin/shipping/shippingPartner/shippingPartnerSlice";
import { checkAccess } from "@utils/helpers";
import { queryHelper } from "@utils/queryHelper";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { FaPencilAlt, FaPlus, FaTrash } from "react-icons/fa";
import { RiSearch2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Input from "@components/Input";
import DeleteDialog from "@components/DeleteDialog";

const ShippingPartner = () => {
  useInjectReducer("shippingPartner", shippingPartnerSlice);
  const navigate = useNavigate();
  const access = useSelector(makeSelectAccess);
  const query = useSelector(makeSelectQuery);
  const dispatch = useDispatch();
  const [queryObj, setQueryObj] = useState({});

  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  //rtk
  const [
    shippingPartner,
    { data: shippingData, isLoading: loading, isSuccess: success },
  ] = useLoadAllShippingPartnerMutation();

  const [deleteShippingPartner] = useDeleteShippingPartnerMutation();
  //   const [deleteMultipleShippingPartner] =
  //     useDeleteMultipleShippingPartnerMutation()

  useEffect(() => {
    shippingPartner();
  }, []);

  const handleOpen = (id) => {
    setDeleteId(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = () => {
    dispatch(setQueryValue({ ...query, ...queryObj }));
    shippingPartner(queryHelper({ ...query, ...queryObj }));
  };

  const handleQueryChange = (name) => (event) => {
    dispatch(setQueryValue({ key: name, value: event.target.value }));
  };

  const handlePagination = ({ page, size }) => {
    dispatch(setQueryValue({ key: "page", value: page }));
    dispatch(setQueryValue({ key: "size", value: size }));
    shippingPartner(queryHelper({ ...query, page, size }));
  };

  const tablePagination = {
    page: shippingData?.page ?? 1,
    size: shippingData?.size ?? 10,
    totalData: shippingData?.totalData ?? 0,
  };
  const handleAddEdit = (id) => {
    if (id !== null) {
      navigate(`/admin/shipping-partner/edit/${id}`);
    } else {
      navigate("/admin/shipping-partner/add");
    }
    // dispatch(clearOne());
  };

  const handleDelete = () => {
    deleteShippingPartner(deleteId)
      .unwrap()
      .then((res) => {
        if (res?.success) {
          dispatch(
            enqueueSnackbar({
              message: res?.msg ?? "Shipping Partner Deleted Successfully.",
              options: {
                variant: "success",
              },
            })
          );
          shippingPartner(queryHelper(query));
          setOpen(false);
        }
      })
      .catch((err) => {
        enqueueSnackbar({
          message: err?.data?.msg ?? "Shipping Partner Delete Failed.",
          options: {
            variant: "warning",
          },
        });
      });
  };

  const tableData = success
    ? shippingData?.data?.map(
        ({ _id, name, is_active, contact_person, order, logic_code }) => [
          // <Checkbox
          //   name={_id}
          //   checked={chosen_shippingPartner.includes(_id)}
          //   onChange={() => dispatch(addChosenShippingPartner(_id))}
          // />,
          name,
          contact_person,
          order,
          logic_code,
          is_active ? "Active" : "Not Active",
          <>
            <div className="flex justify-center mt-1">
              {checkAccess("edit/:id", access) && (
                <button
                  type="button"
                  aria-label="Edit"
                  className="w-6 inline-flex justify-center items-center leading-none cursor-pointer relative"
                  onClick={() => handleAddEdit(_id)}
                >
                  <FaPencilAlt className="tblpencil text-xs text-blue-400 hover:text-blue-500" />
                </button>
              )}
              {checkAccess("delete", access) && (
                <button
                  type="button"
                  className="w-6 inline-flex justify-center item-center leading-none cursor-pointer relative"
                  onClick={() => handleOpen(_id)}
                >
                  <FaTrash className="tbltrash text-xs text-red-400 hover:text-red-500" />
                </button>
              )}
            </div>
          </>,
        ]
      )
    : [];

  return (
    <>
      <DeleteDialog
        open={open}
        doClose={handleClose}
        doDelete={() => handleDelete(deleteId)}
      />
      <Helmet>
        <title>Shipping Partner</title>
        <meta name="description" content="Description of ShippingPartner" />
      </Helmet>

      <div className="flex justify-between mt-3 mb-3" id="page-header">
        {/* {loading && loading == true ? <Loading /> : <></>} */}
        <PageHeader
          title={"Shipping Partner Manage"}
          className={"flex items-center"}
        />
        <div className="flex items-center">
          <Button className="btn btn-admin" onClick={() => handleAddEdit(null)}>
            <div className="flex items-center">
              <FaPlus />
              <span className="pl-2"> Add New</span>
            </div>
          </Button>
        </div>
      </div>
      <PageFilter>
        <div className="grid grid-cols-4 gap-1 w-2/3 items-baseline">
          <FilterInput
            label="Search By Name"
            fieldsetId="contents-name"
            value={query?.find_name ?? ""}
            onChange={handleQueryChange("find_name")}
          />
          <FilterInput
            label="Search By Logic Code"
            fieldsetId="contents-name"
            value={query?.find_logic_code ?? ""}
            onChange={handleQueryChange("find_logic_code")}
          />
          <Button
            leftSection={<RiSearch2Line />}
            isFilter
            onClick={handleSearch}
          >
            Search
          </Button>
        </div>
        {/* <div>
              {chosen_shippingPartner.length > 0 ? (
                <>
                  <div className="flex items-center">
                    <button
                      className="btn bg-danger mr-2"
                      onClick={() =>
                        handleOpenForMultiple(chosen_shippingPartner)
                      }
                    >
                      <div className="flex items-center">
                        <FaTrash />
                        <span className="pl-2"> Delete</span>
                      </div>
                    </button>

                    <button
                      className="btn bg-info"
                      onClick={() => handleActiveAll(chosen_shippingPartner)}
                    >
                      <div className="flex items-center">
                        <span className="pl-2"> Change Status</span>
                      </div>
                    </button>
                  </div>
                </>
              ) : null}
            </div> */}
      </PageFilter>
      <PageContent>
        <Table
          tableHead={[
            //   <MultiCheck
            //     allData={allData}
            //     handleClear={clearChosenShippingPartner}
            //     handleSelect={selectAllShippingPartner}
            //     chosen_items={chosen_shippingPartner}
            //     checker={checker}
            //     selectAll={selectAll}
            //   />,
            "Name",
            "Contact Person",
            "Order",
            "Logic Code",
            "Status",
            <div className="text-center">Action</div>,
          ]}
          tableData={tableData}
          pagination={tablePagination}
          handlePagination={handlePagination}
          emptyDataMsg="No Shipping Partners Found"
          loading={loading}
          ispublic
          isSN
        />
      </PageContent>
    </>
  );
};

export default ShippingPartner;
